import React from 'react';
import CountUp from 'react-countup';
import { Reveal } from './Reveal';

const stats = [
  { value: 100, suffix: '+', label: 'Projects Delivered' },
  { value: 10, suffix: 'K', label: 'Avg. Impressions' },
  { value: 100, suffix: '%', label: 'Satisfaction' },
  { value: 50, suffix: '+', label: 'Happy Clients' }
];

const Stats = () => {
  return (
    <section id="stats" className="py-20 md:py-24 bg-[#0f0f0f] border-y border-white/5" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {stats.map((stat, index) => (
            <Reveal key={index} delay={index * 0.1}>
              <div className="text-center" data-testid={`stat-${index}`}>
                <div className="font-display text-5xl md:text-6xl lg:text-7xl font-semibold gold-gradient leading-none mb-3">
                  <CountUp
                    end={stat.value}
                    suffix={stat.suffix}
                    duration={2.4}
                    enableScrollSpy
                    scrollSpyOnce
                  />
                </div>
                <div className="text-[#a0a0a0] text-sm md:text-base uppercase tracking-[0.15em]">
                  {stat.label}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
